const style = (theme) => {
  const output = {
    root: {
      background: theme.colors[1],
      color: theme.colors[2],
    },
    container: {
      padding: '0 3vw',
      margin: '0 auto',
    },
    containerNewsletter: {
      paddingTop: 40,
    },
    wrapper: {
      padding: '80px 60px',
    },
    footer: {
      '& $wrapper': {
        justifyContent: 'space-between',
        background: theme.colors[3],
        borderTopLeftRadius: 50,
        borderTopRightRadius: 50,
        display: 'flex',
      },
      '& $copy': {
        marginLeft: 100,
        color: theme.colors[2],
      },
    },
    newsletter: {
      marginTop: 150,
      '& $wrapper': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      '& $copy': {
        fontSize: 20,
        textAlign: 'center',
      },
      '& .Form__message': {
        color: theme.colors[2],
      },
    },
    noMargin: {
      marginTop: 0,
    },
    left: {
      display: 'flex',
    },
    right: {
      display: 'flex',
      alignItems: 'flex-end',
      paddingLeft: 40,
    },
    social: {
      fontSize: 13,
      textTransform: 'uppercase',
      fontWeight: 400,
      '& a': {
        fontWeight: 600,
        marginLeft: 5,
        position: 'relative',
        color: theme.colors[0],
        '&:before': {
          content: '""',
          position: 'absolute',
          width: '100%',
          height: 1,
          background: theme.colors[0],
          bottom: 2,
          left: 0,
          transform: 'scaleX(0)',
          transformOrigin: 'left',
          transition: `transform 1s ${theme.easings['power4.out']}`,
        },
        '&:hover': {
          '&:before': {
            transform: 'scaleX(1)',
          },
        },
      },
    },
    logo: {
      display: 'flex',
      alignItems: 'flex-end',
      fontSize: 14,
      '& svg': {
        fill: theme.colors[2],
      },
    },
    copy: {
      fontWeight: 200,
      lineHeight: 1.5,
      fontSize: 14,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      '& p': {
        margin: 0,
      },
      '& p:not(:last-child)': {
        marginBottom: 20,
      },
      '& a': {
        color: theme.colors[2],
        fontWeight: 500,
        '&:hover': {
          color: theme.getRgba(theme.colors[2], 0.5),
        },
      },
      '& a:not([href^="mailto\\:"])': {
        textDecoration: 'underline',
        fontWeight: 400,
        textTransform: 'none',
        letterSpacing: 0,
      },
    },
    copyright: {
      marginTop: 40,
      display: 'flex',
      '& li': {
        marginRight: 10,
      },
      '& $menu': {
        '& a': {
          fontSize: 12,
        },
      },
    },
    footerMenu: {
      flexDirection: 'column',
      marginRight: 100,
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: '-12px',
        height: '100%',
        width: 1,
        background: theme.colors[0],
      },
    },
    menu: {
      position: 'relative',
      display: 'flex',
      flexWrap: 'wrap',
      '& a': {
        position: 'relative',
        color: theme.colors[0],
        textTransform: 'uppercase',
        letterSpacing: 1,
        fontSize: 14,
        '&:before': {
          content: '""',
          position: 'absolute',
          width: '100%',
          height: 1,
          background: theme.colors[0],
          bottom: 2,
          left: 0,
          transform: 'scaleX(0)',
          transformOrigin: 'left',
          transition: `transform 1s ${theme.easings['power4.out']}`,
        },
        '&:hover': {
          '&:before': {
            transform: 'scaleX(1)',
          },
        },
      },
    },
    form: {
      width: '50%',
      '& form': {
        justifyContent: 'center',
      },
    },
  }

  output['@media (max-width: 1180px)'] = {
    footer: {
      '& $copy': {
        marginLeft: 40,
      },
    },
    footerMenu: {
      marginRight: 40,
    },
  }

  output[theme.mediaInverse.md] = {
    copy: {},
    copyright: {
      flexDirection: 'column',
    },
    left: {
      flexDirection: 'column',
      '& $copy': {
        marginLeft: 0,
        marginTop: 40,
      },
    },
    form: {
      width: '100%',
    },
  }

  output[theme.mediaInverse.sm] = {
    wrapper: {
      flexDirection: 'column',
      padding: '80px 40px',
    },
    right: {
      marginTop: 40,
      paddingLeft: 0,
      alignItems: 'unset',
      flexDirection: 'column',
    },
    footerMenu: {
      '&:before': {
        content: 'none',
      },
    },
    social: {
      marginTop: 40,
    },
    newsletter: {
      '& $wrapper': {
        padding: '80px 0',
      },
    },
  }

  return output
}

export default style
